import { FirebaseOptions, initializeApp } from 'firebase/app';
import { browserPopupRedirectResolver, connectAuthEmulator, initializeAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getPerformance } from 'firebase/performance';
import { connectStorageEmulator, getStorage } from 'firebase/storage';
import { Platform } from 'react-native';

import Constants from '@helpers/Constants';
import AuthPersistence from '@helpers/firebase/AuthPersistence';

export const firebaseConfig: FirebaseOptions = Constants.joinstar.firebase;
export const app = initializeApp(firebaseConfig);
export const auth = initializeAuth(app, {
  persistence: AuthPersistence,
  popupRedirectResolver: Platform.select({ web: browserPopupRedirectResolver, default: undefined }),
});
export const firestore = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
export const performance = getPerformance(app);

if (Constants.joinstar.JSEMULATE) {
  const hostname = Platform.select({
    default: '127.0.0.1',
    // 10.0.2.2 is the special IP address to connect to the 'localhost' of
    // the host computer from an Android emulator.
    android: '10.0.2.2',
  });
  connectAuthEmulator(auth, `http://${hostname}:9099`);
  connectFirestoreEmulator(firestore, hostname, 8080);
  connectFunctionsEmulator(functions, hostname, 5001);
  connectStorageEmulator(storage, hostname, 9199);
}
